export const enum GuessType {
	SKIP = 0,
	PARTIAL = 1,
	INCORRECT = 2,
	CORRECT = 3,
}

export const guessTypeInfo: { [k in GuessType]: readonly [string, string] } = {
	[GuessType.CORRECT]: ['correct', 'check'],
	[GuessType.PARTIAL]: ['partial', 'down-left-and-up-right-to-center'],
	[GuessType.INCORRECT]: ['incorrect', 'xmark'],
	[GuessType.SKIP]: ['skipped', 'square'],
} as const;

export const guessTypeEmoji: { [k in GuessType]: string } = {
	[GuessType.CORRECT]: '✅',
	[GuessType.PARTIAL]: '🟧',
	[GuessType.INCORRECT]: '🟥',
	[GuessType.SKIP]: '▪️',
} as const;

export const secondSteps = [1, 1, 2, 3, 4, 5] as const;
export const totalSeconds = secondSteps.reduce((ac, cur) => ac + cur, 0);
